import styled from 'styled-components';
import { renderStyledElementStyles } from '../../../../helpers';

export const PostMessageWrapper = styled.div`
  ${({ theme }) =>
    renderStyledElementStyles(theme, theme.module.vStyles.elements.postMessage)}
  ${({ theme }) =>
    renderStyledElementStyles(theme, theme.module.dStyles.elements.postMessage)}
`;
